// extracted by css-extract-rspack-plugin
export default {"panel":"e0L2h"};